/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MixDesignProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the MixDesign by ID
	 * @param {String|Number} pMixDesignID - The MixDesign ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getMixDesignByID(pMixDesignID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMixDesignID)
			{
				this.pict.log.error('No MixDesign ID provided.');
				return reject(new Error('No MixDesign ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`MixDesign/${pMixDesignID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixDesign: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the MixDesign by ID
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getMixDesigns()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'MixDesigns';

			// Filter out by customer if we have a customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `MixDesigns/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			// Make the request to get MixDesigns
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixDesigns list: ${pError}`, pError);
					return reject(pError);
				}

				resolve(pBody);
			});
		});
	}
}

module.exports = MixDesignProvider;
module.exports.default_configuration = {};
